"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _theme = _interopRequireDefault(require("./compontents/theme"));
var _energy = _interopRequireDefault(require("./compontents/energy"));
var _eedata = _interopRequireDefault(require("./compontents/eedata"));
var _poa = _interopRequireDefault(require("./compontents/poa"));
var _systemParams = _interopRequireDefault(require("./compontents/systemParams"));
var _facilityParams = _interopRequireDefault(require("./compontents/facilityParams"));
var _pie = _interopRequireDefault(require("./compontents/pie"));
var _energySaved = _interopRequireDefault(require("./compontents/energySaved"));
var _ecRatio = _interopRequireDefault(require("./compontents/ecRatio"));
var _home = require("@/api/home");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  name: "BuildOverview",
  components: {
    theme: _theme.default,
    energy: _energy.default,
    system: _systemParams.default,
    facility: _facilityParams.default,
    pie: _pie.default,
    eedata: _eedata.default,
    poa: _poa.default,
    esaved: _energySaved.default,
    ecRatio: _ecRatio.default
  },
  props: {},
  data: function data() {
    return {
      wsIp: process.env.VUE_APP_BASE_API,
      homeData: [],
      projectInfo: {},
      pathData: [],
      notification: {},
      timer: null,
      // 初始定时器变量名为null
      page: 1,
      sbcsData1: {},
      sbcsData2: {},
      sbcsData3: {},
      sbcsData4: {},
      headerData: {}
    };
  },
  computed: {
    isCold: function isCold() {
      return this.$store.state.project.isCold;
    }
  },
  watch: {
    isCold: function isCold(val) {
      this.getProjectListData();
      this.initWebSocket();
      this.initWebSocket1();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch("project/setProjectCold", null);
    if (this.ws) {
      this.ws.close();
    }
    ;
    // js提供的clearInterval方法用来清除定时器
    clearInterval(this.timer);
    this.timer = null; // 这里最好清除一下，回归默认值
  },
  created: function created() {
    this.projectInfo = this.$store.state.project.projectInfo;
    this.getProjectListData();
    this.$store.dispatch("project/setProjectCold", 1);
    // 检测页面访问权限
    var arr = JSON.parse(window.sessionStorage.getItem("menuAuths")) || [];
    this.pathData = arr.map(function (e) {
      return e.path;
    });
    if (this.pathData.indexOf("home-page") !== 0) {
      this.$router.push({
        path: "/403"
      });
      return;
    }
    this.getUntreated();
    this.start();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.setCanvas();
    });
  },
  methods: {
    initWebSocket1: function initWebSocket1() {
      var _this2 = this;
      if ("WebSocket" in window) {
        var i = this.wsIp.indexOf("//");
        var url = this.wsIp.slice(i);
        this.ws = new WebSocket("".concat(process.env.VUE_APP_WSS_STATUS == "true" ? "wss" : "ws", ":").concat(url, "/websocketServer/projectHeader/").concat(this.$store.state.project.projectInfo.id));
        this.ws.onopen = function () {};
        this.ws.onmessage = function (message) {
          var headerData = JSON.parse(message.data);
          for (var key in headerData) {
            switch (key) {
              case "dayCool":
                _this2.headerData.dayCool = headerData[key][0];
                break;
              case "dayCop":
                _this2.headerData.dayCop = headerData[key][0];
                break;
              case "dayElect":
                _this2.headerData.dayElect = headerData[key][0];
                break;
              case "temperatureDifference":
                _this2.headerData.temperatureDifference = headerData[key][0];
                break;
            }
          }
        };
      }
    },
    // 设置canvas偏移位置
    setCanvas: function setCanvas() {
      var canvases = document.querySelectorAll('canvas');
      var zoom = document.body.style.zoom;
      var zoomrAtio = (1 / zoom).toFixed(2);
      var style = {
        zoom: zoomrAtio,
        transform: "scale(".concat(zoom, ")"),
        transformOrigin: '0px 0px'
      };
      for (var i = 0; i < canvases.length; i++) {
        canvases[i].style = style;
      }
    },
    start: function start() {
      var _this3 = this;
      // 将定时器名字赋值到变量中
      this.timer = setInterval(function () {
        _this3.notification = {
          rows: [],
          total: ''
        }; // 每重新都清空原来数据
        _this3.page = 1; // 每次默认第一页查询
        _this3.getUntreated();
      }, 30000);
    },
    // 下拉滑动出发
    getNextDataList: function getNextDataList(page) {
      this.page = page;
      if (page == 1) {
        this.notification = {
          rows: [],
          total: ''
        };
      }
      this.getUntreated();
    },
    getUntreated: function getUntreated() {
      var _this4 = this;
      var par = {
        page: this.page,
        //	页码	query	true	
        rows: 500,
        //	行数	query	true	
        alarmType: '',
        //	告警类型（告警等级）：1提醒2预警3告警	query	false	
        endDate: '',
        //	结束始时间	query	false	
        everconfirmed: '',
        //	是否确认 0.未确认 1.已确认 默认0	query	false	
        projectId: this.$store.state.project.projectInfo.id,
        //	项目id	query	false	
        startDate: '' //	开始时间
      };
      (0, _home.getUntreatedProjectAlarm)(par).then(function (res) {
        if (_this4.notification.rows && _this4.notification.rows.length > 0) {
          _this4.notification.rows = _this4.notification.rows.concat(res.rows); // 下拉加载
        } else {
          _this4.notification = res;
        }
      });
    },
    getProjectListData: function getProjectListData() {
      var _this5 = this;
      (0, _home.getProjectList)({
        projectId: this.$store.state.project.projectInfo.id,
        type: this.isCold || 1
      }).then(function (res) {
        var data = res;
        var sbcs = data[4];
        if (sbcs.length > 0) {
          var i = 1;
          sbcs.forEach(function (item) {
            if (i === 1) {
              _this5.sbcsData1 = _objectSpread(_objectSpread({}, item), {}, {
                img: 'zg_bg'
              });
            }
            if (i === 2) {
              _this5.sbcsData2 = _objectSpread(_objectSpread({}, item), {}, {
                img: 'ldb_bg'
              });
              ;
            }
            if (i === 3) {
              _this5.sbcsData3 = _objectSpread(_objectSpread({}, item), {}, {
                img: 'lqb_bg'
              });
              ;
            }
            if (i === 4) {
              _this5.sbcsData4 = _objectSpread(_objectSpread({}, item), {}, {
                img: 'lqt_bg'
              });
              ;
            }
            i++;
          });
        }
        _this5.homeData = data;
      });
    },
    initWebSocket: function initWebSocket() {
      var _this6 = this;
      // if (this.ws) {
      //   this.ws.close();
      // }
      if ("WebSocket" in window) {
        var i = this.wsIp.indexOf("//");
        var url = this.wsIp.slice(i);
        this.ws = new WebSocket("".concat(process.env.VUE_APP_WSS_STATUS == "true" ? "wss" : "ws", ":").concat(url, "/websocketServer/energyHomePageData/").concat(this.$store.state.project.projectInfo.id, "/").concat(this.isCold));
        this.ws.onopen = function () {};
        this.ws.onmessage = function (message) {
          _this6.homeData = JSON.parse(message.data);
          var scop = _this6.homeData[1][0];
          _this6.headerData.scop = Object.values(scop)[0][0];
          var sbcs = _this6.homeData[4];
          if (sbcs.length > 0) {
            var _i = 1;
            sbcs.forEach(function (item) {
              if (_i === 1) {
                _this6.sbcsData1 = _objectSpread(_objectSpread({}, item), {}, {
                  img: 'zg_bg'
                });
              }
              if (_i === 2) {
                _this6.sbcsData2 = _objectSpread(_objectSpread({}, item), {}, {
                  img: 'ldb_bg'
                });
                ;
              }
              if (_i === 3) {
                _this6.sbcsData3 = _objectSpread(_objectSpread({}, item), {}, {
                  img: 'lqb_bg'
                });
                ;
              }
              if (_i === 4) {
                _this6.sbcsData4 = _objectSpread(_objectSpread({}, item), {}, {
                  img: 'lqt_bg'
                });
                ;
              }
              _i++;
            });
          }
        };
      }
    }
  }
};